import _ from 'lodash';

import { get, CleanSchema } from '../../../json-transform';

const defaultRoiValues = {
  x: 0,
  y: 0,
  width: 0,
  height: 0,
  mode: 'abs',
};

const roiAbsScheme = new CleanSchema({
  x: get('x').asInt().ifEmpty(undefined),
  y: get('y').asInt().ifEmpty(undefined),
  width: get('width').asInt().ifEmpty(undefined),
  height: get('height').asInt().ifEmpty(undefined),
  mode: get('mode'),
});

const roiPercentScheme = new CleanSchema({
  x: get('x').asFloat().ifEmpty(undefined),
  y: get('y').asFloat().ifEmpty(undefined),
  width: get('width').asFloat().ifEmpty(undefined),
  height: get('height').asFloat().ifEmpty(undefined),
  mode: get('mode'),
});

const roiSchemeHandler = (coords) => {
  switch (coords.mode) {
    case 'abs': return roiAbsScheme(coords);
    case 'percent': return roiPercentScheme(coords);
    default: return undefined;
  }
};

export const createRoiScheme = (coords) => {
  if (_.isEqual(coords, defaultRoiValues)) return undefined;

  return roiSchemeHandler(coords);
};

export const readRoiScheme = (coords) => {
  if (!coords) return defaultRoiValues;

  return roiSchemeHandler(coords);
};

const droiSchemeHandler = new CleanSchema({
  area: get('area'),
  form: get('form'),
  mode: get('mode'),
});

export const droiScheme = (coords) => {
  if (!coords.area) return undefined;

  return droiSchemeHandler(coords);
};
